import React from 'react';
import { OptionType } from '@atlaskit/select';

import { useAutoCompleteController } from '@/controllers';

import AdvancedDropdown from '../../advanced-dropdown';
import { NON_COHORT_PREFIX } from '../../constants';

type CohortFilterDropdownProps = {
  publicId: string;
  cohort: string;
  value: string[];
  onChange: (scope: string, value: string[]) => void;
};

const CohortFilterDropdown: React.FC<CohortFilterDropdownProps> = ({
  value,
  onChange,
  publicId,
  cohort,
}) => {
  const renderOptions = async (options: OptionType[]) =>
    options.map(option => ({
      ...option,
      label: option.value || `${NON_COHORT_PREFIX}${cohort.toLowerCase()}`,
      value: option.value || `${NON_COHORT_PREFIX}${cohort.toLowerCase()}`,
    }));
  const loadOptions = useAutoCompleteController('slogroup', {
    formatPlainOption: true,
    typePublicId: publicId,
    params: `cohortType=${cohort}`,
    dynamic: true,
    keepEmptyOptions: true,
  });
  return (
    <AdvancedDropdown
      key={cohort}
      label={cohort}
      placeholder={`Search by ${cohort} name`}
      onChange={(v: string[]) => onChange(cohort, v)}
      value={value}
      loadOptions={async (searchTerm: string) => {
        const res = await loadOptions(searchTerm);
        return renderOptions(res);
      }}
      isAsync
      isMulti
      isSearchable
      menuWidth={360}
      menuHeight={330}
    />
  );
};

export default CohortFilterDropdown;
